<template>
  <div class="notification_channels">

    <div class="channel" v-for="(channel,key) in channels" :key="key">
      <span class="channel_field w10">
        <input class="checkbox" type="checkbox" :id="'checkbox'+key" :value="channel" v-model="notification.channels" >
        <label :for="'checkbox'+key"></label>
      </span>
      <span class="channel_field w40">
        {{ channel.name }}
      </span>
      <span class="channel_field w10">
        <i v-if="channel.type === 'telegram'" title="telegram" class="mdi mdi-telegram"/>
        <i v-if="channel.type === 'email'" title="email" class="mdi mdi-at"/>
      </span>
      <span class="channel_field w40">
        {{ channel.params }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: "notice-channel",
  data () {
    return {
      show: false,
      channels: []
    }
  },
  props: ['notification', 'channels_list'],
  mounted () {
    this.getChannels()
  },
  methods: {
    hide () {
      this.show =! this.show
    },
    getChannels () {
      if (this.channels_list) {
        this.channels = this.channels_list
      }else{
        this.$http.v1.getNotificationChannelsList((response) => {
          let channels = response.data.my

          for (let ch in channels) {
            channels[ch].check = false
          }

          this.channels = channels
        })
      }
    }
  },

}
</script>

<style lang="scss">
 .notification{
    &_channels{
      padding: 1vh 13px 0;
      height: 100%;
      overflow: auto;
      .channel{
        width: 100%;
        display: flex;
        justify-content: space-around;

        background: #f8f8f8;
        border: 1px solid #ddd;
        padding: .35em;
        margin-bottom: -1px;

        &_field{
          display: flex;
          justify-content: space-around;
          &.w10{
            width: 10%;
          }
          &.w40{
            width: 40%;
          }
          .checkbox{
            position: absolute;
            z-index: -1;
            opacity: 0;
            &+label{
              display: inline-flex;
              align-items: center;
              user-select: none;
              &::before {
                content: '';
                display: inline-block;
                width: 1em;
                height: 1em;
                flex-shrink: 0;
                flex-grow: 0;
                border: 1px solid #41B883;
                border-radius: 0.25em;
                margin-right: 0.5em;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 50% 50%;
              }
            }
            &:checked+label::before {
              border-color: #41B883;
              background-color: #41B883;
              background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
            }
            &:focus:not(:checked)+label::before {
              border-color: #41B883;
            }
            &:focus+label::before {
              box-shadow: 0 0 0 0.2rem rgba(65, 184, 131, 0.25);
            }
            &:not(:disabled):active+label::before {
              background-color: #b3d7ff;
              border-color: #b3d7ff;
            }
            &:not(:disabled):not(:checked)+label:hover::before {
              border-color: #41b88394;
            }
          }
        }
      }
    }
 }
</style>
